import { useState } from "react";
import Button from "../Button/Button";
import { FormOptions } from "../FormOptions/FormOptions";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { useUser } from "../../context/UserContext";

export const Form = ({ formData, onComplete }) => {
  const { t } = useTranslation(["customQuestions", "questionsModule"]);
  const { updatePreferredCategory } = useUser();
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(1);
  const [activeQuestion, setActiveQuestion] = useState(formData[1]);

  const loadDefault = () => {
    const initalOptionsValue = {};
    for (let i = 1; i < formData.length; i++) {
      switch (formData[i].type) {
        case "text":
          initalOptionsValue[formData[i].Q] = "";
          break;
        case "multi-options":
          initalOptionsValue[formData[i].Q] = [];
          break;
        default: // single-option
          initalOptionsValue[formData[i].Q] = "";
          break;
      }
    }
    return initalOptionsValue;
  };

  const [selectedOptions, setSelectedOptions] = useState(() => loadDefault());

  const onContinue = () => {
    if (activeQuestionIndex + 1 === formData.length) {
      onComplete(selectedOptions);
    } else {
      setActiveQuestionIndex((prevValue) => prevValue + 1);
      setActiveQuestion(formData[activeQuestionIndex + 1]);
    }

    if (activeQuestionIndex === 0) {
      updatePreferredCategory(
        t(
          `customQuestions:${selectedOptions["question-66dcf2195ba34db99f5e0bf9f1a7638f"]}`,
        ),
      );
    }
  };

  const handleSingleOptionInput = (value) => {
    setSelectedOptions((prevSelectedOption) => ({
      ...prevSelectedOption,
      [activeQuestion.Q]: value,
    }));
  };

  const handleMultiOptionInput = (value) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (value === activeQuestion.resetMapOption) {
        return {
          ...prevSelectedOptions,
          [activeQuestion.Q]: [value],
        };
      }

      let updatedOptions = [...prevSelectedOptions[activeQuestion.Q]];
      updatedOptions = updatedOptions.filter(
        (item) => item !== activeQuestion.resetMapOption,
      );

      const optionIndex = updatedOptions.indexOf(value);
      // Allow atleast one option to be always selected
      if (optionIndex !== -1 && updatedOptions.length === 1) {
        return {
          ...prevSelectedOptions,
          [activeQuestion.Q]: updatedOptions,
        };
      }

      if (optionIndex !== -1) {
        updatedOptions.splice(optionIndex, 1);
      } else {
        updatedOptions.push(value);
      }
      return {
        ...prevSelectedOptions,
        [activeQuestion.Q]: updatedOptions,
      };
    });
  };

  const handleTextInput = (event) => {
    if (event.target.value.length > 100) {
      return;
    }

    const numLines = event.target.value.split("\n").length;

    if (numLines > 1) {
      return;
    }

    setSelectedOptions((prevSelectedOptions) => {
      return {
        ...prevSelectedOptions,
        [activeQuestion.Q]: event.target.value,
      };
    });
  };

  return (
    <>
      <div className="form-module-container">
        <h4 className="form-header">{t(activeQuestion.Q)}</h4>
        {activeQuestion.type === "text" ? (
          <div className="form-text-wrapper">
            <textarea
              rows={5}
              value={selectedOptions[activeQuestion.Q]}
              onChange={(e) => handleTextInput(e)}
              className="form-input-field"
            />
            <p className="form-input-limit">
              {100 - selectedOptions[activeQuestion.Q].length} / 100
            </p>
          </div>
        ) : (
          <div className="form-options-wrapper">
            <FormOptions
              options={activeQuestion.keyMapOptions}
              multiAllowed={activeQuestion.type === "multi-options"}
              selectedOptions={selectedOptions[activeQuestion.Q]}
              onSelect={
                activeQuestion.type === "multi-options"
                  ? handleMultiOptionInput
                  : handleSingleOptionInput
              }
            />
          </div>
        )}
      </div>
      <div className="question-module-btn-wrapper-bottom">
        <Button
          text={t("questionsModule:continue")}
          onClick={() => onContinue()}
          disabled={
            selectedOptions[activeQuestion.Q].length < 1 &&
            activeQuestion.required
          }
        />
      </div>
    </>
  );
};
